// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2506) return "static/chunks/2506-2cf0dd50dcc5ee59.js";
	if (chunkId === 8868) return "static/chunks/8868-4be0ac6b02cc3d05.js";
	if (chunkId === 6465) return "static/chunks/6465-1ce7faf7193f7f5f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"518":"4526540bd023cbac","1659":"f2d8394bd9968c3f","2057":"ed34a467bad8c42a","6725":"217f17bcc5db8bc3","9477":"1bef1da32587ef80"}[chunkId] + ".js";
};